export function excludeBySysId<T extends { sys: { id: string } }>(
  data: T[],
  controlId: string | undefined
): T[] {
  return data.filter((item) => item.sys.id !== controlId)
}
